<template lang="pug">
  SspLayout(area="tnt")
    .row
      .col-md-12
        .panel.panel-default
          .panel-body
            form.form-horizontal(role="form" @submit.prevent="save()")
              .form-group
                label.col-sm-2.control-label Step
                .col-sm-4
                  vSelect(v-model="bizStep" :options="bizSteps" label="value")
                .col-sm-6
                  p(v-if="bizStepText") {{bizStepText}}
              .form-group
                label.col-sm-2.control-label Disposition
                .col-sm-4
                  vSelect(v-model="disposition" :options="dispositions" label="value")
                .col-sm-6
                  p(v-if="dispositionText") {{dispositionText}}
              .form-group
                label.col-sm-2.control-label Location
                .col-sm-4
                  LocationPicker(v-model="location")
              .form-group
                .col-sm-2.col-sm-offset-2
                  input(type='checkbox' v-model="allowImplicitSplit")
                  span.bold Allow implicit split
              .form-group
                label.col-sm-2.control-label Code
                .col-sm-4
                  input.form-control(type="text" v-model="epcs")
                .col-sm-2
                  button.btn.btn-primary.form-control(type="submit" :disabled="!isValid") Register Event
</template>

<script>
import vSelect from 'vue-select'
import miniToastr from 'mini-toastr'
import TrackNTrace from '@/service/apis/TrackNTrace'
import LocationPicker from '@/components/ssp/LocationPicker'
import Util from '@/service/Util'
import { bizStepFilter, dispositionFilter } from './utils'

export default {
  data: () => ({
    allowImplicitSplit: false,
    epcs: null,
    eventTime: null,
    recordTime: null,
    location: null,
    disposition: null,
    bizStep: null,
    bizSteps: [],
    bizStepText: null,
    dispositions: [],
    dispositionText: null,
    errorMsg: null
  }),
  methods: {
    save() {
      const event = {
        allowImplicitSplit: this.allowImplicitSplit,
        epcs: Util.sanitizeCodes(this.epcs),
        location: `urn:kezzler:loc:${this.location.id}`,
        disposition: this.disposition.uri,
        bizStep: this.bizStep.uri
      }

      TrackNTrace.registerTrackingEvent(event)
        .then(() => {
          miniToastr.success('Tracking event registered')
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    }
  },
  created() {
    TrackNTrace.getTrackingDispositions({ size: 1000 })
      .then((resp) => {
        this.dispositions = resp.data.content.map((d) => {
          const opts = {
            name: d.description,
            value: dispositionFilter(d.uri),
            uri: d.uri
          }
          return opts
        })
      })
    TrackNTrace.getTrackingBusinessSteps({ size: 1000 })
      .then((resp) => {
        this.bizSteps = resp.data.content.map((b) => {
          const opts = {
            name: b.description,
            value: bizStepFilter(b.uri),
            uri: b.uri
          }
          return opts
        })
      })
  },
  watch: {
    disposition() {
      if (this.disposition) {
        this.dispositionText = this.disposition.name
      } else {
        this.dispositionText = null
      }
    },
    bizStep() {
      if (this.bizStep) {
        this.bizStepText = this.bizStep.name
      } else {
        this.bizStepText = null
      }
    }
  },
  computed: {
    isValid() {
      return this.location && this.epcs && this.bizStep
    }
  },
  components: {
    LocationPicker,
    vSelect
  },
  filters: {
    bizStep: bizStepFilter,
    disp: dispositionFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/RegisterTrackingevent.vue